import {combineReducers} from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import companies from './slices/companySlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        companies,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
